const creditsPT = {
    "view": {
        "form": {
            "title": "Encomendar Créditos",
            "label": {
                "quantity": "Quantidade"
            },
            "placeholder": {
                "quantity": "Selecionar Quantidade"
            },
            "help_text": {
                "quantity": "Quantidade de créditos que deseja encomendar."
            },
            "button": {
                "placeOrder": "Fazer Encomenda"
            },
            "options": {
                "quantity": {
                    "selectQuantity": "Selecionar Quantidade",
                    "1Credit": "1 Crédito",
                    "2Credits": "2 Créditos",
                    "3Credits": "3 Créditos",
                    "4Credits": "4 Créditos",
                    "5Credits": "5 Créditos",
                    "10Credits": "10 Créditos",
                    "15Credits": "15 Créditos",
                    "20Credits": "20 Créditos",
                    "25Credits": "25 Créditos",
                    "30Credits": "30 Créditos",
                    "35Credits": "35 Créditos",
                    "40Credits": "40 Créditos",
                    "45Credits": "45 Créditos",
                    "50Credits": "50 Créditos",
                    "75Credits": "75 Créditos",
                    "100Credits": "100 Créditos"
                }
            },
            "message": {
                "quantityRequired": "Quantidade é obrigatória",
                "paymentMethodRequired": "Por favor, adicione um <1>método de pagamento</1> para fazer a encomenda de créditos.",
                "paymentMethodExpired": "Não é possível fazer a encomenda de créditos, pois seu <1>método de pagamento</1> padrão expirou, por favor, defina um método de pagamento válido como padrão para fazer a encomenda de créditos."
            }
        },
        "modal": {
            "header": "Prosseguir para o checkout",
            "body": {
                "message": "Você encomendou {{credits}} Créditos",
                "confirmationMessage": "Se deseja confirmar a encomenda, por favor, prossiga para o checkout, caso contrário, pode cancelar a encomenda."
            },
            "button": {
                "cancel": "Cancelar",
                "checkout": "Checkout"
            }
        },
        "message": {
            "error": "Algo deu errado! Por favor, atualize a página e tente novamente!"
        }
    },
    "transactionSuccess": {
        "view": {
            "title": "Transação Bem-Sucedida :)",
            "description": "Você comprou os créditos com sucesso, que serão adicionados à sua conta em breve!",
            "button": {
                "returnToDashboard": "Retornar ao Painel"
            }
        }
    },
    "transactionFailure": {
        "view": {
            "title": "Transação Cancelada :(",
            "description": "A transação foi cancelada... Por favor, tente novamente mais tarde!",
            "button": {
                "returnToDashboard": "Retornar ao Painel"
            }
        }
    }
};

export default creditsPT;